import { defineLabels, resolveLabels } from "@nexus/widget-sdk";

export const LABELS = defineLabels([
  { key: "detections", name: "Detections series (legend)", default: "Detections" },
  {
    key: "cumulativeDetections",
    name: "Detections line in the tooltip",
    default: "Cumulative detections",
  },
  { key: "response", name: "Response series (legend)", default: "Response %" },
  { key: "impact", name: "Impact series (legend)", default: "Impact %" },
  { key: "expectedDetections", name: "Expected detections series (legend)", default: "Expected detections" },
  { key: "anomalies", name: "Anomalies series (legend)", default: "Anomalies" },
  { key: "now", name: "Now line caption and legend entry", default: "Now" },
  { key: "countAxis", name: "Left axis title", default: "Count" },
  { key: "rateAxis", name: "Right axis title", default: "Rate" },
  { key: "eventWindow", name: "Event window band caption", default: "Event window" },
  { key: "blocking", name: "Blocking marker caption", default: "Blocking" },
  { key: "harvesting", name: "Harvesting marker caption", default: "Harvesting" },
  { key: "summaryDetections", name: "Summary heading: detections", default: "Detections" },
  { key: "summaryResponse", name: "Summary heading: response", default: "Response coverage" },
  { key: "summaryImpact", name: "Summary heading: impact", default: "Impact" },
  { key: "dataUnavailable", name: "Summary text when no data", default: "Data unavailable" },
  { key: "resetZoom", name: "Reset zoom button", default: "Reset zoom" },
  { key: "monitoredBy", name: "Monitoring engines caption", default: "Monitored by" },
] as const);

export type EventEvolutionLabels = ReturnType<typeof resolveLabels<typeof LABELS>>;

export const DEFAULT_LABELS: EventEvolutionLabels = resolveLabels(LABELS, undefined);
